import { useTranslation } from "react-i18next";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { useAgreementData } from "../../hooks";
import { formatDateTime } from "@/lib/utils/formatters";
import { CalendarClockIcon } from "lucide-react";
import { EntityListLink } from "@/components/EntityListLink";
import { generatePath } from "react-router-dom";
import { PATH_USER } from "@/constants";

export const AgreementHistorySection = () => {
  const { t } = useTranslation();
  const { history } = useAgreementData();

  if (!history || history.length === 0) {
    return null;
  }

  return (
    <CollapsibleSection title={t("agreements.history.title")}>
      <div className="space-y-4">
        {history.map((entry, index) => (
          <div
            key={index}
            className="relative flex gap-4 pl-8 after:absolute after:left-3 after:top-7 after:bottom-[-1rem] after:w-px after:bg-border after:content-[''] last:after:hidden"
          >
            <CalendarClockIcon className="absolute left-1.5 top-1.5 h-4 w-4" />

            <div className="flex-1 min-w-0 pt-1">
              <p className="text-sm font-bold">
                {t(`agreements.history.actions.${entry.action}`)}
              </p>
              <p className="text-sm text-muted-foreground flex flex-row gap-2">
                {formatDateTime(entry.updated_at)}
              </p>

              <p className="text-sm text-muted-foreground flex flex-row gap-2">
                {entry.user_full_name} ({entry.user_role_name})
                <EntityListLink
                  path={generatePath(PATH_USER, {
                    userId: entry.user_id,
                  })}
                  className="w-5 h-5"
                />
              </p>
            </div>
          </div>
        ))}
      </div>
    </CollapsibleSection>
  );
};
